const getTitleColor = (titleColor) => {
    switch (titleColor) {
        case "yellow":
        return "!text-yellow-400";
        case "black":
        return "!text-gray-900";
        case "white":
        return "!text-white";  
        default:
        return "!text-yellow-400";
    }
}

export default getTitleColor;